(function () {
  'use strict';

  function authInterceptorConfig($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
  }

  angular
    .module('inspinia', [
      'inspinia.auth',
      'inspinia.home',
      'inspinia.temp',
      'inspinia.quotes',
      'inspinia.invoice',
      'inspinia.door',
      'inspinia.users',      
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'ui.router.title',
      'ngStorage',
      'environment',
      'datePicker',
      'firebase',
      'ui-notification',
      'angularMoment',
      'ngMap',
      'ngclipboard'
    ])
    .config(authInterceptorConfig)
    .config(inspiniaConfig);

  function inspiniaConfig(envServiceProvider) {
    // set the domains and variables for each environment

    envServiceProvider.config({ //eslint-disable-line angular/module-getter, angular/di
      domains: {
        development: ['localhost'],
        production: ['glmc.biz']
      },
      vars: {
        development: {
          apiKey: "AIzaSyAAUUk2wxVwW3U8AFyWij7ZhabipPnwu_g",
          authDomain: "glmc-portal-dev.firebaseapp.com",
          databaseURL: "https://glmc-portal-dev.firebaseio.com",
          projectId: "glmc-portal-dev",
          storageBucket: "glmc-portal-dev.appspot.com",
          messagingSenderId: "762617540585"
        },
        production: {
          apiKey: "AIzaSyDjXKUBECZdc3TrgHDn0A9DLY-oKcRWAvE",
          authDomain: "glmc.biz",
          databaseURL: "https://glmc-portal.firebaseio.com",
          storageBucket: "glmc-portal.appspot.com",
          messagingSenderId: "557495987279"
        }
      }
    });

    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();

    //Initialize Firebase with the correct environment settings
    firebase.initializeApp(envServiceProvider.data.vars[envServiceProvider.get()]); //eslint-disable-line no-undef

  }

})();

(function () {
  'use strict';

  angular.module('inspinia').service('UserService', UserService);

  /* @ngInject */
  UserService.$inject = ['firebase', '$firebaseObject', '$firebaseArray', '$q'];

  function UserService(firebase, $firebaseObject, $firebaseArray, $q) {
    var sv = this;

    var role_DOORACCESS = 'DOOR-ACCESS-24-7';
    var role_INVOICEACCESS = 'INVOICING';
    var role_QUOTEACCESS = 'QUOTING';    
    var role_ADMIN = 'ADMIN';

    sv.getUser = function(userID) {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child('employees').child(userID); // TODO: Change this node to 'users'
      var refObj = $firebaseObject(ref);

      refObj.$loaded().then(function () {
        dfd.resolve(refObj);
      }, function (err) {
        dfd.reject(err);
      });

      return dfd.promise;
    };

    sv.getUsers = function() {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child('employees'); // TODO: Change this node to 'users'
      var refObj = $firebaseArray(ref);

      refObj.$loaded().then(function () {
        dfd.resolve(refObj);
      }, function (err) {
        dfd.reject(err);
      });

      return dfd.promise;
    };

    sv.isAdmin = function(user) {
      return user.roles && user.roles[role_ADMIN];
    };

    sv.hasInvoiceAccess = function(user) {
      return user.roles && user.roles[role_INVOICEACCESS];
    };

    sv.hasQuoteAccess = function(user) {
      return user.roles && user.roles[role_QUOTEACCESS];
    };

    sv.hasDoorAccess = function(user) {
      return user.roles && user.roles[role_DOORACCESS];
    };
  }
})();

(function() {
  'use strict';

    angular
        .module('inspinia.users', [
            'ui.router'
        ]);

})();

'use strict';

angular.module('inspinia.users')
  .controller('UserController', UserController);

  UserController.$inject = ['UserService', '$log', 'Notification', '$uibModal'];


function UserController(UserService, $log, Notification, $uibModal) {
  var vm = this;
  vm.customURL = undefined;


  vm.updateRole = function(user){
    UserService.getUser(user.$id).then(function(data){
      var userObj = data;
      userObj.roles = user.roles;
      userObj.$save().then(function(){
        $log.log('Role updated');
      }, function(error){
        Notification.error('An error occurred. Check the console.');
        $log.log(error);      
      });
    });
    
  };

  /*
    Gets all the invoices in an array called invoice_list and loops through them. 
    instantiates an amtPaid variable to 0.0 for each invoice. Then loops through each 
    payment made on that invoice. Divides this number by 100 to get a nice "price" decimal. 
    Then IF the payment doesn't have a stripe error (card declined, etc) that makes it a valid payment
    so we can add that payment amount to our aggregate variable amtPaid on the invoice and use it later
    to calculate if the entire invoice has been paid or only part or none at all.  
  */
  function loadUsers() {
    UserService.getUsers().then(
      function (data) {
        vm.user_list = data;
      },
      function () {
        Notification.error("There was a problem loading the invoices");
      }
    );
  }


  function init() {
    loadUsers();
  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia.users')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.users', {
        url: "/users",
        templateUrl: "app/users/views/user.list.html",
        controller: "UserController",
        controllerAs: "ctrl",
        data: { pageTitle: 'User Management'}
      });
  }

})();

(function() {
  'use strict';

    angular
        .module('inspinia.temp', [
            'ui.router'
        ]);

})();

'use strict';

angular.module('inspinia.temp')
  .service('TempService', TempService);

TempService.$inject = [];
function TempService() {

}

'use strict';

angular.module('inspinia.temp')
  .controller('TempController', TempController);

TempController.$inject = [];

function TempController() {
  function init() {

  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia.temp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.temp', {
        url: "/temp",
        templateUrl: "app/template-feature/views/temp.html",
        controller: "TempController",
        controllerAs: "tempctrl",
        data: { pageTitle: 'Clone Me'}
      });
  }

})();

(function() {
  'use strict';

    angular
        .module('inspinia.quotes', [
            'ui.router'
        ]);

})();

'use strict';

angular.module('inspinia.quotes')
  .service('QuoteService', QuoteService);

QuoteService.$inject = ['$q', 'firebase', '$firebaseArray', '$firebaseObject', '$log'];
function QuoteService($q, firebase, $firebaseArray, $firebaseObject, $log) {
  var sv = this;

  /**
   * Get requests from Firebase. flag pulls from pending or archived accordingly
   * @param isPending
   * @return {Function}
   */
  sv.getRequests = function (requestType) {
    var dfd = $q.defer();
    var ref = firebase.database().ref().child("QuoteRequests").child(requestType);
    var refArr = $firebaseArray(ref);

    refArr.$loaded().then(
      function (data) {
        dfd.resolve(data);
      },
      function (err) {
        $log.error(err);
        dfd.reject(err);
      }
    );

    return dfd.promise;
  };

  /**
   * Move request from one parent to another and delete the old record.
   * @param requestId
   * @param fromNode
   * @param toNode
   * @return {Function}
   */
  sv.moveRequest = function (requestId, fromNode, toNode) {
    var dfd = $q.defer();

    var fromRef = firebase.database().ref().child("QuoteRequests").child(fromNode).child(requestId);
    var toRef = firebase.database().ref().child("QuoteRequests").child(toNode).child(requestId);

    fromRef.once('value', function (snapshot) {
      toRef.update(snapshot.val(), function (err) {
        if (err) {
          dfd.reject(err);
          $log.error(err);
        } else {
          fromRef.remove();
          dfd.resolve();
        }
      });
    });

    return dfd.promise;
  };

  /**
   * Set the responded flag to true or false on a request
   * @param requestId
   * @param fromNode
   * @param isResponded
   * @return {Function}
   */
  sv.setRequestResponded = function (requestId, fromNode) {
    var dfd = $q.defer();

    var ref = firebase.database().ref().child("QuoteRequests").child(fromNode).child(requestId);
    var refObj = $firebaseObject(ref);

    refObj.$loaded().then(
      function (data) {
        data.responded = 'true';
        data.$save().then(
          function () {
            dfd.resolve();
          },
          function (err) {
            $log.error(err);
            dfd.reject(err);
          }
        );
      },
      function (err) {
        $log.error(err);
        dfd.reject(err);
      }
    );

    return dfd.promise;
  };

  sv.getRequestById = function(requestId, fromNode){
    var dfd = $q.defer();

    var ref = firebase.database().ref().child('QuoteRequests').child(fromNode).child(requestId);
    var refObj = $firebaseObject(ref);

    refObj.$loaded().then(
      function(data){
        dfd.resolve(data);
      },
      function(err){
        $log.error(err);
        dfd.reject();
      }
    );

    return dfd.promise;
  }
}

'use strict';

angular.module('inspinia.quotes')
  .controller('QuoteRequestController', QuoteController);

QuoteController.$inject = ['QuoteService', 'Notification', '$state', '$stateParams', '$window', 'moment'];

function QuoteController(QuoteService, Notification, $state, $stateParams, $window, moment) {
  var vm = this;
  vm.requestType = 

  /**
   * Move a quote to archived or back to pending
   * @param quoteId
   */
  vm.moveQuote = function (quoteId) {
    QuoteService.moveRequest(quoteId, vm.selectedQuoteType, getInverseQuoteType()).then(
      function () {
        Notification.success("Quote Request Updated");
      },
      function () {
        Notification.error("Quote request could not be updated");
      }
    );
  };

  /**
   * Toggle responded flag to true/false
   * @param quoteId
   * @param responded
   */
  vm.markResponded = function (quote) {
    openGmailResponse(quote);

    QuoteService.setRequestResponded(quote.$id, vm.selectedQuoteType).then(
     function () {
     Notification.success('Quote request updated');
     },
     function () {
     Notification.error('Quote request could not be updated');
     }
     );
  };

  /**
   * Move to details screen with quote information
   * @param quoteId
   */
  vm.viewDetails = function (quoteId) {
    $state.go('app.quote-details', {quoteId: quoteId, fromNode: vm.selectedQuoteType});
  };

  /**
   * Call for change in Quote Type dropdown
   */
  vm.fetchRequests = function () {
    loadQuoteRequests();
  };

  /**
   * Open a response window for the quote request
   * Builds the url string based on quote information
   * @param quote
   */
  function openGmailResponse(quote) {
    var url = 'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=$TO&su=$DATE%20$DEPART%20to%20$ARRIVE&body=$MAILBODY&shva=1';

    //create dates to manipulate format
    var depart = moment(quote.departDate).format('MM/DD');
    var arrive = moment(quote.arriveDate).format('MM/DD');

    //Replace TO
    url = url.replace('$TO', quote.email);

    //Replace Date
    if (depart == arrive) {
      url = url.replace('$DATE', depart);
    } else {
      url = url.replace('$DATE', depart + ' - ' + arrive);
    }

    var newLine = '%0a';

    var mailbody = newLine;
    mailbody += 'Customer: ' + newLine;
    mailbody += '  Name: ' + quote.firstName + ' ' + quote.lastName + newLine;
    mailbody += '  Phone: ' + quote.phone + newLine;
    mailbody += '  Returning Customer: ' + quote.returningCustomer + newLine;
    mailbody += newLine;
    mailbody += 'Group: ' + newLine;
    mailbody += '  Group Name: ' + quote.groupName + newLine;
    mailbody += '  Group Type: ' + quote.groupType + newLine;
    mailbody += '  Trip Type: ' + quote.tripType + newLine;
    mailbody += '  Passengers: ' + quote.passengers + newLine;
    mailbody += '  Group Information: ' + quote.groupInformation + newLine;
    mailbody += newLine;
    mailbody += 'Travel: ' + newLine;
    mailbody += '  Scheduled Departure: ' + quote.departDate + ' ' + quote.departTime + newLine;
    mailbody += '  Departing From: ' + quote.departAddress + ' ' + quote.departCity + ', ' + quote.departState + newLine;
    mailbody += '  Scheduled Arrival: ' + quote.arriveDate + ' ' + quote.arriveTime + newLine;
    mailbody += '  Arriving At: ' + quote.arriveAddress + ' ' + quote.arriveCity + ', ' + quote.arriveState + newLine;
    mailbody += '  Returning: ' + quote.returnDate + ' ' + quote.returnTime + newLine;
    url = url.replace('$MAILBODY', mailbody);

    //Replace Locations
    url = url.replace('$DEPART', capitalize(quote.departCity));
    url = url.replace('$ARRIVE', capitalize(quote.arriveCity));

    //open in new window
    $window.open(url);
  }

  /* Private Functions */
  function init() {
    vm.selectedQuoteType = $stateParams.requestType.charAt(0).toUpperCase() + $stateParams.requestType.slice(1);
    loadQuoteRequests();
  }

  function capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /**
   * fetch quotes from Firebase
   */
  function loadQuoteRequests() {
    QuoteService.getRequests(vm.selectedQuoteType).then(
      function (data) {
        vm.quoteRequests = data;
      },
      function () {
        Notification.error("There was a problem loading quote requests.")
      }
    );
  }

  /**
   * get the inverse of the selected quote type
   * @return {*}
   */
  function getInverseQuoteType() {
    if (vm.selectedQuoteType === 'Pending') {
      return 'Archived';
    }

    return 'Pending';
  }

  init();
}

'use strict';

angular.module('inspinia.quotes')
  .controller('QuoteDetailsController', QuoteDetailsController);

QuoteDetailsController.$inject = ['QuoteService', 'Notification', '$stateParams', '$q', 'GoogleGeocodeService'];

function QuoteDetailsController(QuoteService, Notification, $stateParams, $q, GoogleGeocodeService) {
  var vm = this;

  function init() {
    if ($stateParams.quoteId) {
      QuoteService.getRequestById($stateParams.quoteId, $stateParams.fromNode).then(
        function (data) {
          vm.quote = data;

          var originAddress = vm.quote.departAddress + ' ' + vm.quote.departCity + ' ' + vm.quote.departState;
          var destinationAddress = vm.quote.arriveAddress + ' ' + vm.quote.arriveCity + ' ' + vm.quote.arriveState;

          var qOrigin = GoogleGeocodeService.geocodeAddress(originAddress);
          var qDestination = GoogleGeocodeService.geocodeAddress(destinationAddress);

          $q.all([qOrigin, qDestination]).then(
            function (data) {
              vm.originCoors = data[0].lat + ',' + data[0].lng;
              vm.destinationCoors = data[1].lat + ',' + data[1].lng;
            },
            function(){
              vm.hideMap = true;
            }
          )

        },
        function () {
          Notification.error("Quote request could not be found");
        }
      );
    }
  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia.quotes')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.archived-requests', {
        url: "/requests/:requestType",
        templateUrl: "app/quotes/views/quote-list.html",
        controller: "QuoteRequestController",
        controllerAs: "requestctrl",
        data: { pageTitle: 'Archived Quote Requests'},
        params: {
          requestType: null
        }
      })
      .state('app.pending-requests', {
        url: "/requests/:requestType",
        templateUrl: "app/quotes/views/quote-list.html",
        controller: "QuoteRequestController",
        controllerAs: "requestctrl",
        data: { pageTitle: 'Pending Quote Requests'},
        params: {
          requestType: null
        }
        
      })
      .state('app.quote-details', {
        url: "/quote-details/:quoteId",
        templateUrl: "app/quotes/views/quote-details.html",
        controller: "QuoteDetailsController",
        controllerAs: "detailsctrl",
        data: { pageTitle: 'Quote Details'},
        params: {
          quoteId: null,
          fromNode: null
        }
      });
  }

})();

(function() {
  'use strict';

    angular
        .module('inspinia.invoice', [
            'ui.router'
        ]);

})();

'use strict';

angular.module('inspinia.invoice')
  .service('InvoiceService', InvoiceService);

InvoiceService.$inject = ['$q', 'firebase', '$firebaseArray', '$firebaseObject', '$log'];

function InvoiceService($q, firebase, $firebaseArray, $firebaseObject, $log) {
  var sv = this;

  // pushes the invoice and attempts to return the key of the node pushed
  // return this here because otherwise we lose track of which invoice we just pushed
  sv.pushInvoice = function (object) {
    return firebase.database().ref('Invoices/').push({
      firstName: object.first_name,
      lastName: object.last_name,
      groupName: object.group_name,
      email: object.email,
      invoiceNum: object.invoice_number,
      invoiceAmount: object.invoice_amount,
      ccFee: object.ccFee ? 'true': 'false',
      invoiceLink: object.link
    }).key;
  }

  sv.updateLink = function (key, url) {
    $log.log('update key and link: ' + key + ' ' + url + '\n');
    firebase.database().ref('Invoices/' + key).update({
      invoiceLink: url
    });
  }

  // retrieves list of invoices
  sv.getInvoices = function () {
    var dfd = $q.defer();
    var ref = firebase.database().ref('Invoices');
    var refArr = $firebaseArray(ref);

    refArr.$loaded().then(
      function (data) {
        dfd.resolve(data);
      },
      function (err) {
        $log.error(err);
        dfd.reject(err);
      }
    );

    sv.deleteInvoice = function (invoiceID) {
      var ref = firebase.database().ref('Invoices');
      ref.child(invoiceID).remove();


    }

    return dfd.promise;
  };
}

'use strict';

angular.module('inspinia.invoice')
  .controller('InvoiceController', InvoiceController);

InvoiceController.$inject = ['InvoiceService', '$log', 'Notification', '$uibModal'];


function InvoiceController(InvoiceService, $log, Notification, $uibModal) {
  var vm = this;
  vm.customURL = undefined;

    // gonna set up the dummy to hold the field data
  vm.dummyInvoice= {
    first_name: '',
    last_name: '',
    group_name: '',
    email: '',
    invoice_number: '',
    invoice_amount: '',
    link: '',
    ccFee: true
  };
  
  // called after copying the invoice url to their clipboard
  // clears the fields, resets the available button, and prints a notification of success
  vm.resetForm = function(){
    vm.customURL = undefined;
    vm.notifySuccess();
  }

  vm.notifySuccess = function(){
    Notification.success("Invoice URL was successfully copied to your clipboard");
  }
  // base url
  var urlString = "www.greatlakesmotorcoach.com/pay-online-great-lakes-motorcoach.php?ID=";
  // will hold our custom key we get from firebase
  var tempKey = "";
  
  // call pushInvoice   
  // set tempKey equal to the string returned by pushInvoice
  // call our url generator method to set our new URL equal to vm.customURL
  // NOTE: we generate the URL after pushing the invoice because
  // the URL requires the key and the key is not generated by firebase
  // until it is pushed
  vm.generateInvoice = function(){
    vm.customURL= undefined;
    tempKey = InvoiceService.pushInvoice(vm.dummyInvoice);
    generateURL();
    InvoiceService.updateLink(tempKey, vm.customURL);
    loadInvoices();
    Notification.success("Your invoice was successfully created");
    vm.dummyInvoice = {};

  }

  // Adds invoice deletion functionality to the button on the invoice page
  // opens a modal and displays the invoice information
  // if the user hits "ok" then I call the deleteInvoice in the service
  // to delete the invoice from firebase and reload the invoices
  vm.deleteInvoice = function(invoiceID, invoice){
    $uibModal.open({
      templateUrl: 'app/invoicing/views/delete-modal.html',
      size: 'md',
      controller: function($uibModalInstance) {
        var modalvm = this;
        modalvm.deletedInvoice = invoice;         // passes the invoice into the modal controller to be used in the modal view
        modalvm.ok = function() {
          InvoiceService.deleteInvoice(invoiceID) // delete the invoice
          loadInvoices();                         // reload the invoice list so the display updates
          $uibModalInstance.close();
        };

        modalvm.cancel=function() {
          $uibModalInstance.close();
        };
      },
      controllerAs: 'modalctrl' 
    });

  }
  // concatonate base url and our new firebase key into a controller object called customURL  
  function generateURL(){
    vm.customURL = urlString + tempKey;
    //vm.copyTextToClipboard(vm.customURL);
  }
  
  /*
    Gets all the invoices in an array called invoice_list and loops through them. 
    instantiates an amtPaid variable to 0.0 for each invoice. Then loops through each 
    payment made on that invoice. Divides this number by 100 to get a nice "price" decimal. 
    Then IF the payment doesn't have a stripe error (card declined, etc) that makes it a valid payment
    so we can add that payment amount to our aggregate variable amtPaid on the invoice and use it later
    to calculate if the entire invoice has been paid or only part or none at all.  
  */
  function loadInvoices() {
    InvoiceService.getInvoices().then(
      function (data) {
        vm.invoice_list = data;
        _.each(vm.invoice_list, function(inv){
          inv.amtPaid = 0.0;
          _.each(inv.Payments, function(payment) {
            var test = parseFloat(100.00).toFixed(2);
            payment.paymentAmount = parseFloat(payment.paymentAmount)/(test);

            if(!payment.hasOwnProperty('stripeError') || (payment.stripeError && payment.stripeError.length === 0)){
              inv.amtPaid = (parseFloat(inv.amtPaid + payment.paymentAmount)).toFixed(2);
            }
          })
        })
      },
      function () {
        Notification.error("There was a problem loading the invoices");
      }
    );
  }
  
  /*
    Takes in the invoice amount and paid amount and compares, returns a boolean 
    to determine if the entire invoice has been paid
    Call this in view to avoid too much logic in the view. 
  */
  vm.paidInFull = function(invAmt, paidAmt) {
    invAmt = parseFloat(invAmt);
    paidAmt = parseFloat(paidAmt);
    if(paidAmt >= invAmt) {
      return true;
    }
    else {
      return false;
    }
  }


  function init() {
    loadInvoices();
  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia.invoice')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.invoice', {
        url: "/invoice-url",
        templateUrl: "app/invoicing/views/payment-url-form.html",
        controller: "InvoiceController",
        controllerAs: "ctrl",
        data: { pageTitle: 'Invoice URL Generator'}
      });
  }

})();

'use strict';

angular.module('inspinia.temp')
  .service('TempService', TempService);

TempService.$inject = [];
function TempService() {

}

'use strict';

angular.module('inspinia.temp')
  .controller('TempController', TempController);

TempController.$inject = [];

function TempController() {
  function init() {

  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia.temp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.temp', {
        url: "/temp",
        templateUrl: "app/template-feature/views/temp.html",
        controller: "TempController",
        controllerAs: "tempctrl",
        data: { pageTitle: 'Clone Me'}
      });
  }

})();

'use strict';

angular.module('inspinia')
  .controller('HomeController', HomeController);

HomeController.$inject = [];

function HomeController() {
    var vm = this;
    vm.message = "Home Page";
}

(function() {
  'use strict';

    angular
        .module('inspinia.home', [
            'ui.router'
        ]);

})();

(function() {
  'use strict';

  angular
    .module('inspinia.home')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.main', {
        url: "/home",
        templateUrl: "app/home/views/home.html",
        controller: "HomeController",
        controllerAs: "home",
        data: { pageTitle: 'Home'}
      });
  }

})();

(function() {
  'use strict';

    angular
        .module('inspinia.door', [
            'ui.router'
        ]);

})();


'use strict';


angular.module('inspinia.door')
  .service('DoorService', DoorService);

DoorService.$inject = ['$q', 'firebase', '$firebaseArray'];
function DoorService($q, firebase, $firebaseArray) {
  var sv = this;

  sv.getDoors = function () {
    var dfd = $q.defer();

    var ref = firebase.database().ref().child('accessControl').child("doorStatus");
    var refArr = $firebaseArray(ref);

    refArr.$loaded().then(
      function (data) {
        dfd.resolve(data);
      },
      function (err) {
        dfd.reject(err);
      }
    );

    return dfd.promise;
  };

  sv.sendDoorRequest = function(requestModel){
    var dfd = $q.defer();

    var ref = firebase.database().ref().child('accessControl').child('doorRequests');
    var refArr = $firebaseArray(ref);

    refArr.$add(requestModel).then(
      function(){
        dfd.resolve();
      },
      function(err){
        dfd.reject(err);
      }
    );

    return dfd.promise;
  }

}

'use strict';


angular.module('inspinia.door')
  .controller('DoorController', DoorController);

DoorController.$inject = ['Auth', 'DoorService', 'Notification', '$log', 'moment'];

function DoorController(Auth, DoorService, Notification, $log, moment) {
  var vm = this;

  vm.toggleDoorStatus = function(door){
    var doorRequestModel = {
      action: (door.locked) ? 'unlock' : 'lock',
      doorId: door.$id,
      timestamp: new moment().toISOString(),
      userId: Auth.$getAuth().uid
    };

    door.loading = true;

    DoorService.sendDoorRequest(doorRequestModel).finally(
      function(){
        door.loading = false;
      }
    );
  };

  function init() {
    getDoors();
  }

  function getDoors() {
    DoorService.getDoors().then(
      function (data) {
        vm.doors = data;
      },
      function(err){
        Notification.error("Doors could not be fetched");
        $log.error(err)
      }
    );
  }


  init();


}

(function() {
  'use strict';
  

  angular
    .module('inspinia.door')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('app.doors', {
        url: "/doors",
        templateUrl: "app/door/views/door.html",
        controller: "DoorController",
        controllerAs: "doorctrl",
        data: { pageTitle: 'Door Access'}
      });
  }

})();

(function () {
  'use strict';

  angular.module('inspinia').service('GoogleGeocodeService', GoogleGeocodeService);

  /* @ngInject */
  GoogleGeocodeService.$inject = ['$resource', '$q'];

  function GoogleGeocodeService($resource, $q) {
    var sv = this;
    var baseUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=:addr&key=:key";

    sv.geocodeAddress = function (address) {
      var dfd = $q.defer();
      var webAddr = address.split(' ').join('+');

      var res = $resource(
        baseUrl,
        {
          addr: '@addr',
          key: 'AIzaSyChujgfAiXuJK-9CC4lRIbKam5VDcBgxkg'
        }
      );

      res.get({addr: webAddr},
        function (data) {
        if(data.results[0]) {
          dfd.resolve(data.results[0].geometry.location);
        }else{
          dfd.reject();
        }
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('inspinia').service('FirebaseService', FirebaseService);

  /* @ngInject */
  FirebaseService.$inject = ['$firebaseObject', '$firebaseArray', 'firebase', '$q'];

  function FirebaseService($firebaseObject, $firebaseArray, firebase, $q) {
    var sv = this;

    /**
     * Get all clients
     * @return Clients
     */
    sv.getClients = function () {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child("clients");
      var refObj = $firebaseObject(ref);

      refObj.$loaded().then(function () {
          dfd.resolve(refObj);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };

    /**
     * Get all clients as an array
     * @return Clients
     */
    sv.getClientsArray = function () {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child("clients");
      var array = $firebaseArray(ref);

      array.$loaded().then(function () {
          dfd.resolve(array);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };

    /**
     * Get all project statuses
     * @return Project statuses
     */
    sv.getProjectStatuses = function () {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child("projectStatuses");
      var obj = $firebaseObject(ref);

      obj.$loaded().then(function () {
          dfd.resolve(obj);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };

    /**
     * Get all employees
     * @return promise for employees
     */
    sv.getEmployees = function () {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child("employees");
      var refArr = $firebaseArray(ref);

      refArr.$loaded().then(function () {
          dfd.resolve(refArr);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };

    /**
     * Get all employees
     * @return promise for employees
     */
    sv.getEmployeesObject = function () {
      var dfd = $q.defer();

      var ref = firebase.database().ref().child("employees");
      var refObj = $firebaseObject(ref);

      refObj.$loaded().then(function () {
          dfd.resolve(refObj);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };

    /**
     * Fetch tasks
     * @returns task promise
     */
    sv.getTasks = function () {
      var dfd = $q.defer();
      var ref = firebase.database().ref().child("tasks");
      var refObj = $firebaseObject(ref);

      refObj.$loaded().then(function () {
          dfd.resolve(refObj);
        },
        function (err) {
          dfd.reject(err);
        });

      return dfd.promise;
    };
  }
})();

'use strict';

angular.module('inspinia')
  .controller('MainController', MainController);

MainController.$inject = ['Auth', '$rootScope', '$state', '$firebaseObject', 'firebase', '$location', 'envService', 'UserService'];

function MainController(Auth, $rootScope, $state, $firebaseObject, firebase, $location, envService, UserService) {
  var vm = this;
  vm.auth = Auth;
  vm.$state = $state;
  vm.fromState = 'app.pending-requests';

  var stateChangeDeregistration = $rootScope.$on('$stateChangeSuccess', function(ev, to, toParams, from) {
    vm.fromState = from.name;
  });

  $rootScope.$on('$destroy', stateChangeDeregistration);

  vm.logout = function () {
    vm.auth.$signOut().then(function () {
      $state.go('auth.login');
    }, function () {
      // Error
    });
  };

  vm.auth.$onAuthStateChanged(function (firebaseUser) {
    if (firebaseUser) {
      vm.currentUser = firebaseUser;
      vm.photoUrl = firebaseUser.providerData[0].photoURL;
      getCurrentEmployee();
    }
  });

  function getCurrentEmployee() {
    // var ref = firebase.database().ref().child("employees").child(vm.currentUser.uid);
    // var employeeObj = $firebaseObject(ref);

    UserService.getUser(vm.currentUser.uid).then(function(user) {
      vm.hasInvoiceAccess = UserService.hasInvoiceAccess(user);
      vm.hasQuoteAccess = UserService.hasQuoteAccess(user);      
      vm.isAdmin = UserService.isAdmin(user);
      vm.hasDoorAccess = UserService.hasDoorAccess(user);

    }, function(err) {
      Notification.error('Error getting current user');
      $log.log(err);
    });
    
    // employeeObj.$loaded().then(function () {
    //   vm.isAdmin = employeeObj.roles && employeeObj.roles.admin;
    // });
  }

  function init() {
    vm.environment = envService.get();

    vm.currentPath = $location.path();
    vm.isPending = (vm.currentPath.toUpperCase().indexOf('PENDING') >= 0);
  }

  init();
}

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
        abstract: true,
        url: "/app",
        controller: "HomeController",
        controllerAs: "home",
        templateUrl: "app/common/views/content.html"
      });
      

    $urlRouterProvider.otherwise('/auth/login');
  }

})();

(function() {
  'use strict';

    angular
        .module('inspinia.auth', [
            'ui.router'
        ]);

})();

'use strict';

angular.module('inspinia.auth')
  .service('AuthService', AuthService);

/**
 * Quick and Dirty auth stubs
 * Token is saved on service object
 * Could be implemented with $localStorage or $cookies to save between page refresh
 * @type {string[]}
 */
AuthService.$inject = ['$http', '$q', '$localStorage', 'envService', 'firebase', '$firebaseObject'];
function AuthService($http, $q, $localStorage, envService, firebase, $firebaseObject){
  var sv = this;
  var baseUrl = envService.read('databaseURL');

    /*
  sv.login = function(data){
    var dfd = $q.defer();
    $http({
      method: 'POST',
      data: JSON.stringify(data),
      url: baseUrl + 'login'
    }).then(
      function(resp) {
        $localStorage.authToken = resp.data.access_token;
        dfd.resolve();
      },
      function(err) {
        dfd.reject(err);
        //display message to user
      }
    );

    return dfd.promise;
  };

  sv.logout = function(data){

    var dfd = $q.defer();
    $http({
      method: "POST",
      data: JSON.stringify(data),
      url: baseUrl + 'logout'
    }).then(
      function(resp){
        $localStorage.$reset();
        dfd.resolve(resp);
      },
      function(err){
        dfd.reject(err);
      }
    );
    return dfd.promise;
  };
  */

  sv.resetPassword = function(data){
    return $http({
      method: "POST",
      data: angular.toJson(data),
      url: baseUrl + 'resetPassword'
    });
  };

  sv.getAuthToken = function(){
    return $localStorage.authToken;
  };

  /**
   * Fetch user by id
   * @return {*}
   */
  sv.getEmployeeById = function (uid) {
    var dfd = $q.defer();

    var ref = firebase.database().ref().child("employees").child(uid);
    var refObj = $firebaseObject(ref);

    refObj.$loaded().then(function () {
          dfd.resolve(refObj);
        },
        function (err) {
          dfd.reject(err);
        });

    return dfd.promise;
  };




}

'use strict';

angular.module('inspinia.auth')
  .controller('AuthController', AuthController);

AuthController.$inject = ['Auth', '$state', '$log', 'AuthService'];

function AuthController(Auth, $state, $log, authService) {
  var vm = this;
  vm.credentials = {login: {}, reset: {}, register: {}};
  vm.auth = Auth;

  vm.loginWithGoogle = function () {
    vm.auth.$signInWithPopup("google").then(function () {
      // Login successful...handle in $onAuthStateChanged()
    }).catch(function (error) {
      $log.log("Authentication failed: ", error);
    });
  };

  vm.auth.$onAuthStateChanged(function (firebaseUser) {
    vm.firebaseUser = firebaseUser;

    if (firebaseUser && emailIsValid(firebaseUser.email)) {
      // Add the employee to the employee table
      updateEmployee(firebaseUser);

      // Redirect to the time entry screen
      $state.go('app.pending-requests', {requestType: 'pending'});
    }
  });

  function updateEmployee(firebaseUser) {
    authService.getEmployeeById(firebaseUser.uid).then(
        function(data){
          var employeeObj = data;
          if (employeeObj.$value === null) {
            // Employee not found...add to database
            employeeObj.name = vm.firebaseUser.displayName;
            employeeObj.email = vm.firebaseUser.email;
            employeeObj.roles = { 'ADMIN': false };
            employeeObj.$save();
          }
        },
        function(err){
          $log.error(err);
        }

    );
  }

  function emailIsValid() {
    return true;
  }

  vm.forgotPassword = function () {
    vm.working = true;

    Auth.resetPassword(vm.credentials.reset).then().finally(
      function () {
        vm.working = false;
      }
    );
  }
}

(function() {
  'use strict';

  angular
    .module('inspinia.auth')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('auth', {
        url: "/auth",
        template: "<ui-view></ui-view>",
        abstract: true,
        defaultChild: "app.auth.login"
      })
      .state('auth.login', {
        url: "/login",
        templateUrl: "app/auth/views/auth.login.html",
        controller: "AuthController",
        controllerAs: "auth",
        data: { pageTitle: 'Login', specialClass: 'gray-bg' }
      })
      .state('auth.login_2', {
        url: "/login2",
        templateUrl: "app/auth/views/auth.login_two_columns.html",
        controller: "AuthController",
        controllerAs: "auth",
        data: { pageTitle: 'Login 2', specialClass: 'gray-bg' }
      })
      .state('auth.register', {
        url: "/register",
        templateUrl: "app/auth/views/auth.register.html",
        controller: "AuthController",
        controllerAs: "auth",
        data: { pageTitle: 'Register', specialClass: 'gray-bg' }
      })
      .state('auth.forgot_password', {
        url: "/forgot_password",
        templateUrl: "app/auth/views/auth.forgot_password.html",
        controller: "AuthController",
        controllerAs: "auth",
        data: { pageTitle: 'Password Recovery', specialClass: 'gray-bg' }
      })
      .state('auth.lockscreen', {
        url: "/lockscreen",
        templateUrl: "app/auth/views/auth.lockscreen.html",
        controller: "AuthController",
        controllerAs: "auth",
        data: { pageTitle: 'Lockscreen', specialClass: 'gray-bg' }
      });
  }

})();


'use strict';
angular.module('inspinia.auth')
    .factory('AuthInterceptor', AuthInterceptor);

/* @ngInject */
AuthInterceptor.$inject = ['$q','$location', '$localStorage'];

function AuthInterceptor ($q, $location, $localStorage) {

    var authInterceptorServiceFactory = {};

    var _request = function (config) {
        config.headers = config.headers || {};

        var token = $localStorage.authToken;
        if (token) {
            config.headers.Authorization = 'Bearer ' + token;
        }

        return config;
    };

    var _responseError = function (rejection) {
        if (rejection.status === 401) {
            $location.path('/login');
        }
        return $q.reject(rejection);
    };

    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.responseError = _responseError;

    return authInterceptorServiceFactory;
}

'use strict';

angular.module('inspinia.auth')
    .factory('Auth', Auth);

Auth.$inject = ['$firebaseAuth'];

function Auth($firebaseAuth) {
    return $firebaseAuth();
}
(function() {
  'use strict';

    angular
        .module('inspinia.temp', [
            'ui.router'
        ]);

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });
            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
  .directive("pageTitle", function($rootScope, $timeout){
          return {
              link: function(scope, element) {
                  var listener = function(event, toState) {
                      // Default title - load on Dashboard 1
                      var title = 'Responsive Admin Theme';
                      // Create your own title pattern
                      if (toState.data && toState.data.pageTitle) title =toState.data.pageTitle;
                      $timeout(function() {
                          element.text(title);
                      });
                  };
                  var stateChange = $rootScope.$on('$stateChangeStart', listener);
                  $rootScope.$on('$destroy', stateChange);
              }
      };
  })
  .directive('icheck',function($timeout){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, $attrs, ngModel) {
        return $timeout(function() {
          var value;
          value = $attrs['value'];

          $scope.$watch($attrs['ngModel'], function(newValue){
            $(element).iCheck('update');
          });

          return $(element).iCheck({
            checkboxClass: 'icheckbox_square-green',
            radioClass: 'iradio_square-green'

          }).on('ifChanged', function(event) {
            if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
              $scope.$apply(function() {
                return ngModel.$setViewValue(event.target.checked);
              });
            }
            if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
              return $scope.$apply(function() {
                return ngModel.$setViewValue(value);
              });
            }
          });
        });
      }
    };
  });

//ChosenJS directive
// Generated by CoffeeScript 1.8.0
(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  angular.module('inspinia').directive('chosen', [ // eslint-disable-line
    '$timeout', function($timeout) {
      var CHOSEN_OPTION_WHITELIST, NG_OPTIONS_REGEXP, isEmpty, snakeCase;
      NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/;
      CHOSEN_OPTION_WHITELIST = ['noResultsText', 'allowSingleDeselect', 'disableSearchThreshold', 'disableSearch', 'enableSplitWordSearch', 'inheritSelectClasses', 'maxSelectedOptions', 'placeholderTextMultiple', 'placeholderTextSingle', 'searchContains', 'singleBackstrokeDelete', 'displayDisabledOptions', 'displaySelectedOptions', 'width'];
      snakeCase = function(input) {
        return input.replace(/[A-Z]/g, function($1) {
          return "_" + ($1.toLowerCase());
        });
      };
      isEmpty = function(value) {
        var key;
        if (angular.isArray(value)) {
          return value.length === 0;
        } else if (angular.isObject(value)) {
          for (key in value) {
            if (value.hasOwnProperty(key)) {
              return false;
            }
          }
        }
        return true;
      };
      return {
        restrict: 'A',
        require: '?ngModel',
        priority: 1,
        link: function(scope, element, attr, ngModel) {
          var chosen, defaultText, disableWithMessage, empty, initOrUpdate, match, options, origRender, removeEmptyMessage, startLoading, stopLoading, valuesExpr, viewWatch;
          element.addClass('localytics-chosen');
          options = scope.$eval(attr.chosen) || {};
          angular.forEach(attr, function(value, key) {
            if (__indexOf.call(CHOSEN_OPTION_WHITELIST, key) >= 0) {
              return options[snakeCase(key)] = scope.$eval(value);
            }
          });
          startLoading = function() {
            return element.addClass('loading').attr('disabled', true).trigger('chosen:updated');
          };
          stopLoading = function() {
            return element.removeClass('loading').attr('disabled', false).trigger('chosen:updated');
          };
          chosen = null;
          defaultText = null;
          empty = false;
          initOrUpdate = function() {
            if (chosen) {
              return element.trigger('chosen:updated');
            } else {
              chosen = element.chosen(options).data('chosen');
              return defaultText = chosen.default_text;
            }
          };
          removeEmptyMessage = function() {
            empty = false;
            return element.attr('data-placeholder', defaultText);
          };
          disableWithMessage = function() {
            empty = true;
            return element.attr('data-placeholder', chosen.results_none_found).attr('disabled', true).trigger('chosen:updated');
          };
          if (ngModel) {
            origRender = ngModel.$render;
            ngModel.$render = function() {
              origRender();
              return initOrUpdate();
            };
            if (attr.multiple) {
              viewWatch = function() {
                return ngModel.$viewValue;
              };
              scope.$watch(viewWatch, ngModel.$render, true);
            }
          } else {
            initOrUpdate();
          }
          attr.$observe('disabled', function() {
            return element.trigger('chosen:updated');
          });
          if (attr.ngOptions && ngModel) {
            match = attr.ngOptions.match(NG_OPTIONS_REGEXP);
            valuesExpr = match[7];
            var timer;
            scope.$watchCollection(valuesExpr, function(newVal) {
              return timer = $timeout(function() {
                if (angular.isUndefined(newVal)) {
                  return startLoading();
                } else {
                  if (empty) {
                    removeEmptyMessage();
                  }
                  stopLoading();
                  if (isEmpty(newVal)) {
                    return disableWithMessage();
                  }
                }
              });
            });
            return scope.$on('$destroy', function() {
              if (typeof timer !== "undefined" && timer !== null) {
                return $timeout.cancel(timer);
              }
            });
          }
        }
      };
    }
  ]);

}).call(this);

/**
 * INSPINIA - Responsive Admin Theme
 * 2.6.2
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/views/auth.forgot_password.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">Forgot password</h2><p>Enter your email address and your password will be reset and emailed to you.</p><div class=\"row\"><div class=\"col-lg-12\"><form class=\"m-t\" role=\"form\" action=\"index.html\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" placeholder=\"Email address\" ng-model=\"auth.credentials.register.email\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\"><span ng-if=\"!auth.working\">Send new password</span><div ng-if=\"auth.working\" class=\"sk-spinner sk-spinner-wave\"><span class=\"sk-rect1\"></span> <span class=\"sk-rect2\"></span> <span class=\"sk-rect3\"></span> <span class=\"sk-rect4\"></span> <span class=\"sk-rect5\"></span></div></button></form></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div></div>");
$templateCache.put("app/auth/views/auth.lockscreen.html","<div class=\"lock-word animated fadeInDown\"><span class=\"first-word\">LOCKED</span><span>SCREEN</span></div><div class=\"middle-box text-center lockscreen animated fadeInDown\"><div><div class=\"m-b-md\"><img alt=\"image\" class=\"img-circle circle-border\" src=\"https://s3.amazonaws.com/uifaces/faces/twitter/ok/128.jpg\"></div><h3>John Smith</h3><p>Your are in lock screen. Main app was shut down and you need to enter your password to go back to app.</p><form class=\"m-t\" role=\"form\" action=\"index.html\"><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"******\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width\">Unlock</button></form></div></div>");
$templateCache.put("app/auth/views/auth.login.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><div><img class=\"logo hidden-xs\" src=\"/assets/images/glmc-logo.png\"></div><h2 class=\"text-white\">Admin Portal</h2><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-click=\"auth.loginWithGoogle()\">Login with Google</button></div></div>");
$templateCache.put("app/auth/views/auth.login_two_columns.html","<div class=\"loginColumns animated fadeInDown\"><div class=\"row\"><div class=\"col-md-6\"><h2 class=\"font-bold\">Welcome to IN+</h2><p>Perfectly designed and precisely prepared admin theme with over 50 pages with extra new web app views.</p><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.</p><p>When an unknown printer took a galley of type and scrambled it to make a type specimen book.</p><p><small>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</small></p></div><div class=\"col-md-6\"><div class=\"ibox-content\"><form class=\"m-t\" role=\"form\" action=\"index.html\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" placeholder=\"Username\" required=\"\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\"><span ng-if=\"!auth.working\">Login</span><div ng-if=\"auth.working\" class=\"sk-spinner sk-spinner-wave\"><span class=\"sk-rect1\"></span> <span class=\"sk-rect2\"></span> <span class=\"sk-rect3\"></span> <span class=\"sk-rect4\"></span> <span class=\"sk-rect5\"></span></div></button> <a href=\"#\"><small>Forgot password?</small></a><p class=\"text-muted text-center\"><small>Do not have an account?</small></p><a class=\"btn btn-sm btn-white btn-block\" href=\"register.html\">Create an account</a></form><p class=\"m-t\"><small>Inspinia we app framework base on Bootstrap 3 &copy; 2014</small></p></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div></div>");
$templateCache.put("app/auth/views/auth.register.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><div><h1 class=\"logo-name\">IN+</h1></div><h3>Register to IN+</h3><p>Create account to see it in action.</p><form class=\"m-t\" role=\"form\" action=\"login.html\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"auth.credentials.register.user\" placeholder=\"Name\" required=\"\"></div><div class=\"form-group\"><input type=\"email\" class=\"form-control\" ng-model=\"auth.credentials.register.email\" placeholder=\"Email\" required=\"\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" ng-model=\"auth.credentials.register.pass\" placeholder=\"Password\" required=\"\"></div><div class=\"form-group\"><div class=\"checkbox i-checks\"><label><input ng-model=\"auth.credentials.register.agree\" type=\"checkbox\"><i></i> Agree the terms and policy</label></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\"><span ng-if=\"!auth.working\">Register</span><div ng-if=\"auth.working\" class=\"sk-spinner sk-spinner-wave\"><span class=\"sk-rect1\"></span> <span class=\"sk-rect2\"></span> <span class=\"sk-rect3\"></span> <span class=\"sk-rect4\"></span> <span class=\"sk-rect5\"></span></div></button><p class=\"text-muted text-center\"><small>Already have an account?</small></p><a class=\"btn btn-sm btn-white btn-block\" ui-sref=\"login\">Login</a></form><p class=\"m-t\"><small>Inspinia we app framework base on Bootstrap 3 &copy; 2014</small></p></div></div>");
$templateCache.put("app/common/views/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/common/views/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/common/views/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/common/views/footer.html\'\"></div></div></div>");
$templateCache.put("app/common/views/errorOne.html","<div class=\"middle-box text-center animated fadeInDown\"><h1>404</h1><h3 class=\"font-bold\">Page Not Found</h3><div class=\"error-desc\">Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.<form class=\"form-inline m-t\" role=\"form\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Search for page\"></div><button type=\"submit\" class=\"btn btn-primary\">Search</button></form></div></div>");
$templateCache.put("app/common/views/errorTwo.html","<div class=\"middle-box text-center animated fadeInDown\"><h1>500</h1><h3 class=\"font-bold\">Internal Server Error</h3><div class=\"error-desc\">The server encountered something unexpected that didn\'t allow it to complete the request. We apologize.<br>You can go back to main page:<br><a href=\"index.html\" class=\"btn btn-primary m-t\">Dashboard</a></div></div>");
$templateCache.put("app/common/views/footer.html","<div class=\"footer\"><small class=\"pull-right text-capitalize\">{{main.environment}}</small><div><strong>Copyright</strong> Owl Computing Inc. 2016</div></div>");
$templateCache.put("app/common/views/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/common/views/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\"><img src=\"../../../assets/images/glmc-logo.png\" class=\"nav-image img-responsive\"> <span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"nav-email font-bold\">{{main.currentUser.email}}</strong></span></span></div></li><li ui-sref-active=\"active\" ng-show=\"main.hasQuoteAccess\"><a ui-sref=\"app.pending-requests({requestType:\'pending\'})\"><i class=\"fa fa-file-text-o\"></i> <span class=\"nav-label\">Incoming</span></a></li><li ui-sref-active=\"active\" ng-show=\"main.hasQuoteAccess\"><a ui-sref=\"app.archived-requests({requestType:\'archived\'})\"><i class=\"fa fa-archive\"></i> <span class=\"nav-label\">Archived</span></a></li><li ui-sref-active=\"active\" ng-show=\"main.hasInvoiceAccess\"><a ui-sref=\"app.invoice\"><i class=\"fa fa-credit-card\"></i> <span class=\"nav-label\">Invoicing</span></a></li><li ui-sref-active=\"active\" ng-show=\"main.hasDoorAccess\"><a ui-sref=\"app.doors\"><i class=\"fa fa-key\"></i> <span class=\"nav-label\">Doors</span></a></li><li ui-sref-active=\"active\" ng-show=\"main.isAdmin\"><a ui-sref=\"app.users\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Users</span></a></li><li ui-sref-active=\"active\"><a ng-click=\"main.logout()\"><i class=\"fa fa-sign-out\"></i> <span class=\"nav-label\">Logout</span></a></li></ul></div></nav>");
$templateCache.put("app/common/views/topnavbar.html","<div class=\"row border-bottom visible-xs\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div></nav></div>");
$templateCache.put("app/door/views/door.html","<div id=\"doors\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>Access Control</h2></div></div><div class=\"wrapper wrapper-content row\"><div ng-repeat=\"door in doorctrl.doors\" class=\"col-sm-6 col-md-4 col-lg-3 text-center m-t-md\"><div class=\"ibox-content door-button\" ng-click=\"doorctrl.toggleDoorStatus(door)\"><div class=\"row m-t-sm\"><div><div ng-class=\"{\'unlock-green\': !door.locked, \'text-danger\': door.locked}\"><i class=\"fa fa-5x\" ng-class=\"{\'fa-lock\':door.locked, \'fa-unlock-alt\':!door.locked}\"></i></div><h3 class=\"m-t-sm\">{{door.$id}}</h3></div></div></div></div></div></div>");
$templateCache.put("app/home/views/home.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>{{main.helloText}}</h1><small>{{home.message}} <i class=\"glyphicon glyphicon-pencil\"></i></small></div><div class=\"text-center\"><small>Auth Token: <b>{{home.authToken}}</b></small></div><div><h1>User</h1>User ID: {{home.user}}<br>User: {{home.userobject}}</div><div>FB data:<h4 ng-repeat=\"project in home.projects\">{{project}}</h4></div></div></div></div>");
$templateCache.put("app/in/views/temp.html","<div id=\"temp\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>Page Header</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><h3>Page Content Here</h3></div></div></div></div>");
$templateCache.put("app/invoicing/views/delete-modal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Delete Invoice?</h4></div><div class=\"modal-body\"><p>Are you sure you want to delete this invoice?</p><p><strong>Invoice Number:</strong>{{modalctrl.deletedInvoice.invoiceNum}}</p><p><strong>Name:</strong>{{modalctrl.deletedInvoice.firstName}} {{modalctrl.deletedInvoice.lastName}}</p><p><strong>Email:</strong>{{modalctrl.deletedInvoice.email}}</p><p><strong>Group:</strong>{{modalctrl.deletedInvoice.groupName}}</p><p><strong>Amount:</strong>{{modalctrl.deletedInvoice.invoiceAmount}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"modalctrl.cancel()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"modalctrl.ok()\">Delete</button></div></div>");
$templateCache.put("app/invoicing/views/payment-url-form.html","<div id=\"invoice\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>Invoice Management</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><form name=\"ctrl.urlForm\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>First Name</label> <input id=\"nameinput\" type=\"text\" name=\"firstname\" ng-model=\"ctrl.dummyInvoice.first_name\" placeholder=\"First Name\" class=\"form-control\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Last Name</label> <input type=\"text\" name=\"lastname\" ng-model=\"ctrl.dummyInvoice.last_name\" placeholder=\"Last Name\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Group Name</label> <input type=\"text\" name=\"groupname\" ng-model=\"ctrl.dummyInvoice.group_name\" placeholder=\"Group Name\" class=\"form-control\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Email</label> <input type=\"email\" name=\"email\" ng-model=\"ctrl.dummyInvoice.email\" placeholder=\"Email\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Invoice Number</label><div class=\"input-group m-b\"><span class=\"input-group-addon\">#</span> <input name=\"invoicenum\" type=\"text\" ng-model=\"ctrl.dummyInvoice.invoice_number\" class=\"form-control\" required=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Invoice Amount</label><div class=\"input-group m-b\"><span class=\"input-group-addon\">$</span> <input name=\"invoiceamount\" placeholder=\"00.00\" ng-model=\"ctrl.dummyInvoice.invoice_amount\" type=\"text\" class=\"form-control\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label><input name=\"ccFee\" placeholder=\"00.00\" ng-model=\"ctrl.dummyInvoice.ccFee\" type=\"checkbox\" icheck=\"\" class=\"\"> Include Stripe Fee (3%)</label></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><button class=\"btn btn-sm btn-primary\" type=\"button\" ng-click=\"ctrl.generateInvoice();\" ng-disabled=\"ctrl.urlForm.$invalid\"><strong>Add New Invoice</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"button\" ngclipboard=\"\" data-clipboard-text=\"{{ctrl.customURL}}\" ng-if=\"ctrl.customURL\" ng-click=\"ctrl.resetForm()\"><strong>Copy URL</strong></button></div></div></form></div></div><div id=\"invoice-list\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>All Invoices</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"col-md-6\"><strong>Click on any invoice number to copy its custom URL to your clipboard</strong></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input name=\"search\" placeholder=\"Search by name, email, invoice number, or group name\" type=\"text\" class=\"form-control\" ng-model=\"searchText\"></div></div></div><table class=\"table table-bordered\"><thead><tr class=\"bg-muted\"><th>Invoice Number</th><th>First Name</th><th>Last Name</th><th>Group Name</th><th>Email</th><th>Invoice Amount</th><th>Amount Paid</th><th>Paid</th><th>Delete</th></tr></thead><tbody><tr ng-repeat=\"invoice in ctrl.invoice_list | filter : searchText | orderBy : \'invoiceNum\'\"><td style=\"text-align:center;\"><button class=\"btn btn-sm btn-primary invoiceButton\" ngclipboard=\"\" data-clipboard-text=\"{{invoice.invoiceLink}}\" ng-click=\"ctrl.notifySuccess()\">{{invoice.invoiceNum}}</button></td><td>{{invoice.firstName}}</td><td>{{invoice.lastName}}</td><td>{{invoice.groupName}}</td><td>{{invoice.email}}</td><td>{{invoice.invoiceAmount}}</td><td>{{invoice.amtPaid}}</td><td class=\"text-center\"><i ng-if=\"!ctrl.paidInFull(invoice.invoiceAmount, invoice.amtPaid)\" class=\"x-red fa fa-close\"></i> <i ng-if=\"ctrl.paidInFull(invoice.invoiceAmount, invoice.amtPaid)\" class=\"check-green fa fa-check\"></i></td><td class=\"text-center\"><button class=\"btn btn-sm btn-primary delete btn-danger\" type=\"button\" ng-click=\"ctrl.deleteInvoice(invoice.$id, invoice)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/quotes/views/quote-details.html","<div id=\"temp\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>Quote Request Details</h2></div></div><div class=\"m-t-md\"><a ui-sref=\"{{main.fromState}}\"><i class=\"fa fa-chevron-left\"></i> Back to Requests</a></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 border-bottom m-b-sm\"><h2>Customer</h2></div></div><div class=\"row\"><div class=\"col-md-4\"><label>First Name</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.firstName}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Last Name</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.lastName}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Email</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.email}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Phone</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.phone}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Returning Customer</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.returningCustomer}}</span></div></div></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 border-bottom m-b-sm\"><h2>Group</h2></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Group Name</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.groupName}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Group Type</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.groupType}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Trip Type</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.tripType}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Passengers</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.passengers}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Group Information</label></div><div class=\"col-md-8\">{{detailsctrl.quote.groupInformation}}</div></div></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 border-bottom m-b-sm\"><h2>Travel</h2></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Departure Date/Time</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.departDate}}</span> <span>{{detailsctrl.quote.departTime}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Departure Address</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.departAddress}}</span> <span>{{detailsctrl.quote.departCity}},</span> <span>{{detailsctrl.quote.departState}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Arrival Date/Time</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.arriveDate}}</span> <span>{{detailsctrl.quote.arriveTime}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Arrival Address</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.arriveAddress}}</span> <span>{{detailsctrl.quote.arriveCity}},</span> <span>{{detailsctrl.quote.arriveState}}</span></div></div><div class=\"row\"><div class=\"col-md-4\"><label>Returning Date/Time</label></div><div class=\"col-md-8\"><span>{{detailsctrl.quote.returnDate}}</span> <span>{{detailsctrl.quote.returnTime}}</span></div></div></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12 border-bottom m-b-sm\"><h2>Map</h2></div></div><div class=\"row\" ng-if=\"!detailsctrl.hideMap\"><ng-map zoom-to-include-markers=\"true\"><directions draggable=\"true\" panel=\"map-panel\" travel-mode=\"DRIVING\" waypoint=\"\" origin=\"{{detailsctrl.originCoors}}\" destination=\"{{detailsctrl.destinationCoors}}\"></directions></ng-map><div id=\"map-panel\"></div></div><div class=\"row\" ng-if=\"detailsctrl.hideMap\"><h3>No Map Data Available</h3></div></div></div></div>");
$templateCache.put("app/quotes/views/quote-list.html","<div id=\"quote-list\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2 ng-if=\"requestctrl.selectedQuoteType == \'Archived\'\">Archived Requests</h2><h2 ng-if=\"requestctrl.selectedQuoteType == \'Pending\'\">Incoming Requests</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><table class=\"table table-bordered\"><thead><tr class=\"bg-muted\"><th>Responded</th><th>Name</th><th>Email</th><th>Submitted</th><th>Group Name</th><th>Group Type</th><th>Trip Type</th><th class=\"text-center\">Manage</th></tr></thead><tbody><tr ng-repeat=\"quote in requestctrl.quoteRequests | orderBy: \'submittedDateTime\':true\"><td class=\"text-center\"><button class=\"btn-small custom-btn-size m-b-xs\" ng-class=\"{\'btn-success\': quote.responded == \'true\',\'btn-warning\': quote.responded == \'false\'}\" ng-click=\"requestctrl.markResponded(quote)\"><span ng-if=\"quote.responded == \'false\'\">Respond</span> <span ng-if=\"quote.responded == \'true\'\">Responded</span></button></td><td>{{quote.firstName}} {{quote.lastName}}</td><td>{{quote.email}}</td><td>{{quote.submittedDateTime | date:\'YYYY-DD-MM hh:mm a\'}}</td><td>{{quote.groupName}}</td><td>{{quote.groupType}}</td><td>{{quote.tripType}}</td><td class=\"text-center\"><div><button class=\"btn-small btn-info m-b-xs custom-btn-size\" ng-click=\"requestctrl.viewDetails(quote.$id)\">View Details</button> <button class=\"btn-small btn-danger custom-btn-size\" ng-click=\"requestctrl.moveQuote(quote.$id, quote.responded)\"><span ng-if=\"requestctrl.selectedQuoteType == \'Pending\'\">Archive</span> <span ng-if=\"requestctrl.selectedQuoteType == \'Archived\'\">Unarchive</span></button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/template-feature/views/temp.html","<div id=\"temp\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>Page Header</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"row\"><h3>Page Content Here</h3></div></div></div></div>");
$templateCache.put("app/users/views/user.list.html","<div id=\"users\"><div id=\"user-list\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-md-12\"><h2>All Users</h2></div></div><div class=\"ibox m-t-md\"><div class=\"ibox-content\"><div class=\"col-md-6\"><strong>Use check boxes to adjust permissions for each user</strong></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group m-b\"><span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span> <input name=\"search\" placeholder=\"Search by name, email, invoice number, or group name\" type=\"text\" class=\"form-control\" ng-model=\"searchText\"></div></div></div><table class=\"table table-bordered\"><thead><tr class=\"bg-muted\"><th>Name</th><th>Email</th><th class=\"text-center\">ADMIN <i class=\"fa fa-small fa-info-circle\" uib-tooltip=\"Gives access to the user screen where permissions are set.\" tooltip-popup-delay=\"1000\"></i></th><th class=\"text-center\">DOOR-ACCESS <i class=\"fa fa-small fa-info-circle\" uib-tooltip=\"Allows user access and open doors.\" tooltip-popup-delay=\"1000\"></i></th><th class=\"text-center\">INVOICING <i class=\"fa fa-small fa-info-circle\" uib-tooltip=\"Gives access to the invoicing screen.\" tooltip-popup-delay=\"1000\"></i></th><th class=\"text-center\">QUOTING <i class=\"fa fa-small fa-info-circle\" uib-tooltip=\"Gives access to the incoming and archived quote screens.\" tooltip-popup-delay=\"1000\"></i></th></tr></thead><tbody><tr ng-repeat=\"user in ctrl.user_list | filter : searchText | orderBy : \'lastName\'\"><td>{{user.name}}</td><td>{{user.email}}</td><td><div class=\"center-check\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-change=\"ctrl.updateRole(user)\" ng-model=\"user.roles[\'ADMIN\']\"></div></td><td><div class=\"center-check\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-change=\"ctrl.updateRole(user)\" ng-model=\"user.roles[\'DOOR-ACCESS-24-7\']\"></div></td><td><div class=\"center-check\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-change=\"ctrl.updateRole(user)\" ng-model=\"user.roles[\'INVOICING\']\"></div></td><td><div class=\"center-check\"><input icheck=\"\" class=\"form-control\" type=\"checkbox\" ng-change=\"ctrl.updateRole(user)\" ng-model=\"user.roles[\'QUOTING\']\"></div></td></tr></tbody></table></div></div></div></div>");}]);